<div *ngFor="let form of formList; let i = index" class="d-flex py-1">

    <div class="w-50 px-1">
      <div class="input-group">
        <div class="input-group-prepend"><span class="input-group-text px-1 px-sm-2">A partir de</span></div>
        <input [readonly]="disabled===true" (focus)="updateValidators()" [formControl]="form.controls.min" type="number" [max]="i==formList.length-1 ? '' : (formList[i+1].controls.min.value || 2) - 1"
          [min]="i==0 ? 1 : formList[i-1].controls.min.value + 1" placeholder="Unidades" class="form-control">
      </div>
      <app-msg-erro [control]="form.controls.min"></app-msg-erro>
    </div>

    <div class="w-50 px-1">
      <div class="input-group">
        <div class="input-group-prepend"><span class="input-group-text px-1 px-sm-2">R$</span></div>
        <input [readonly]="disabled===true" [textMask]="masks.moeda" [formControl]="form.controls.valorConsulta" type="text" placeholder="Preço unitário" class="form-control">
      </div>
      <app-msg-erro [control]="form.controls.valorConsulta"></app-msg-erro>
    </div>

    <div *ngIf="!disabled" class="px-1">
      <button *ngIf="i==0" (click)="addRange()" class="btn btn-sm btn-icon btn-success rounded-circle">
        <i class="mdi mdi-plus"></i>
      </button>

      <button *ngIf="i>0" [disabled]="i<formList.length-1" (click)="deleteRange()" [ngClass]="{'btn-danger' : i==formList.length-1}"
        class="btn btn-sm btn-icon rounded-circle">
        <i class="mdi mdi-minus"></i>
      </button>


    </div>

  </div>
